import {SmartFormBasicDataStore} from "./SmartFormBasicDataStore";

export class SmartFormRepeaterDataStore extends SmartFormBasicDataStore {
    public defaultValue: any;
    public rows:any[];
    public label:string;
    public numericalValue:number;
    public OriginalValues:any;
    public value:string;
    constructor() {
        super('value');
        this.rows=[];
    }


    public toString() {
        alert('Sorry a repeater field can not be used in formulas like this');
    }

    public Clone(){
        return  (Object as any).assign( Object.create( Object.getPrototypeOf(this)), this);
    }

}







// WEBPACK FOOTER //
// ./formBuilder/dataStores/SmartFormRepeaterDataStore.ts